function GetAccessToken(){
      //const clientId = '96983d4e41c54cd7ad191464a4ce0781';
      //  const clientSecret = 'e2cddd8f63ff4ce99419bdf3d538f323'; 
         const clientId = '9896ed189cbc4b2b90b91b1df77418ab';
        const clientSecret = '022542c6b8f143a885e615d1dfb17bef';
        const url = 'https://accounts.spotify.com/api/token';
        const postData = {
          grant_type: 'client_credentials',
          client_id: clientId,
          client_secret: clientSecret
        };
      
        jQuery.ajax({
          url: url,
          type: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: postData,
          success: function(response) {
            const accessToken = response.access_token;
            const expirationTime = new Date().getTime() + (response.expires_in * 1000);
            sessionStorage.setItem('spotify_access_token', accessToken);
            sessionStorage.setItem('spotify_token_expiration', expirationTime);
            setTimeout(function() {
              sessionStorage.removeItem('spotify_access_token');
              sessionStorage.removeItem('spotify_token_expiration');
              console.log('Access token expired and removed from session.');
            }, response.expires_in * 1000);
            //console.log('Access token stored in session:', accessToken);
          },
          error: function(xhr, status, error) {
            console.error('Error:', error);
          }
        });
    } 

$(document).ready(function () {
  let searchTimeout;

  GetAccessToken();

  async function searchSpotify(keyword) {
    const searchResults = jQuery("#search-results");

    if (!keyword || keyword.length < 2) {
      searchResults.hide().html("");
      return;
    }

    const accessToken = sessionStorage.getItem("spotify_access_token");

    if (!accessToken) {
      //searchResults.show().html("<p>Spotify token not found.</p>");
      //return;
       GetAccessToken();
    }

    searchResults.show().html("<p>Searching...</p>");

    try {
      const response = await fetch(
        `https://api.spotify.com/v1/search?q=${encodeURIComponent(keyword)}&type=track&limit=10`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );

      const data = await response.json();

      searchResults.html("");

      if (data.tracks && data.tracks.items.length > 0) {
        data.tracks.items.forEach(function (item) {
          const image = item.album?.images?.[0]?.url || "";
          const songName = item.name || "";
          const artistName = item.artists?.[0]?.name || "";
          const songId = item.id || "";
          const albumId = item.album?.id || "";
          const artistId = item.artists?.[0]?.id || "";

          const Song = `
            <a href="/pages/spotify-promotion?SongID=${songId}&AlbumID=${albumId}&ArtistID=${artistId}" class="result-opt">
              <div class="img-box">
                ${image ? `<img src="${image}" alt="${songName}">` : ""}
              </div>
              <p>${songName} <span class="ByArtist">${artistName}</span></p>
            </a>
          `;

          searchResults.append(Song);
        });
      } else {
        searchResults.html(`<div class="spotify-no-results">No songs found</div>`);
      }
    } catch (error) {
      console.error(error);
      searchResults.html(`<div class="spotify-error">Something went wrong.</div>`);
    }
  }

  $("#search-box-email").on("keyup", function () {
    const keyword = $(this).val().trim();

    clearTimeout(searchTimeout);

    searchTimeout = setTimeout(function () {
      searchSpotify(keyword);
    }, 500);
  });

  $("#ShopifySearch").on("submit", function (e) {
    e.preventDefault();

    const keyword = $("#search-box-email").val().trim();
    searchSpotify(keyword);
  });
});
